import { render, staticRenderFns } from "./FullContent.vue?vue&type=template&id=5afa2696"
import script from "./FullContent.vue?vue&type=script&lang=js"
export * from "./FullContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports